const setAuthAction = ({ commit }, payload) => {
  commit('setAuth', payload)
}

const setCanViewerShare = ({ commit }, payload) => {
  commit('setCanViewerShare', payload)
}

const setCanEditPresentation = ({ commit }, payload) => {
  commit('setCanEditPresentation', payload)
}

const setCurrentTokenValue = ({ commit }, payload) => {
  commit('setCurrentTokenValue', payload)
}

const setIsNewPresentationAction = ({ commit }, payload) => {
  commit('setIsNewPresentation', payload)
}

export default {
  setAuthAction,
  setCanViewerShare,
  setCanEditPresentation,
  setCurrentTokenValue,
  setIsNewPresentationAction,
}
